export const environment = {
  apiUrl: 'https://api.stage.betterchains.net',
  siteUrl: 'https://admin.stage.betterchains.net',
  staticUrl: '',
};
